<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Collection Name for where the entity instance is stored in Cosmos:
      <input type="text" [(ngModel)]="seConfiguration.CollectionName" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Partition Key, also to specify where the entity instance is stored in Cosmos:
      <input type="text" [(ngModel)]="seConfiguration.PartitionKey" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      The path of the property you want to check the identifier against:
      <input type="text" [(ngModel)]="seConfiguration.IdentifyingFieldPath" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      The identifier you want to use for the above path to find the entity to edit:
      <input type="text" [(ngModel)]="seConfiguration.IdentifyingFieldValue" />
    </label>
    <label>
      The type of value being used to find the entity to edit
    </label>
    <div class="cell medium-2">
      <select name="typeOfIdentifyingField" name="typeOfIdentifyingField" [(ngModel)]="seConfiguration.TypeOfIdentifyingField">
        <option value="0" selected>String</option>
        <option value="1">Boolean</option>
        <option value="2">Decimal</option>
        <option value="3">Int</option>
        <option value="4">DateTime</option>
      </select>
    </div>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      A period separated path for where the field is stored in the Json object (ex for org entity: "address.city"):
      <input type="text" [(ngModel)]="seConfiguration.PropertyToReplacePath" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      The value to be saved off to that path:
      @if (!seConfiguration.ValueToSaveIsCurrentDateTime) {
        <input type="text" [(ngModel)]="seConfiguration.ValueToSave" />
      }
    </label>
    <label>
      The type of value being saved off
    </label>
    <div class="cell medium-2">
      <select name="typeOfValueToSave" name="typeOfValueToSave" [(ngModel)]="seConfiguration.TypeOfValueToSave">
        <option value="0" selected>String</option>
        <option value="1">Boolean</option>
        <option value="2">Decimal</option>
        <option value="3">Int</option>
        <option value="4">DateTime</option>
      </select>
      @if (seConfiguration.TypeOfValueToSave === '4') {
        <div>
          Should the value be the current DateTime at runtime?
          <input type="checkbox" [(ngModel)]="seConfiguration.ValueToSaveIsCurrentDateTime" />
        </div>
      }
    </div>
  </div>
</div>